import React, { ReactElement } from 'react';

import { Image } from '../Image';
import { IHeroProps } from './Hero.types';

export const Hero: React.FC<IHeroProps> = ({
	image,
	title,
	hasImage = true,
}: IHeroProps): ReactElement => (
	<header className="c-hero">
		<h2 className="c-hero__title u-text-c u-color-secondary">{title}</h2>
		{hasImage && (
			<Image
				image={image}
				wrapperClassName="c-hero__image"
				imageClassName="c-image--cover-top"
			/>
		)}
	</header>
);
